import React from 'react';
import { useTranslation } from 'react-i18next';

const revenueData = [1200, 1800, 1400, 2100, 1900, 2400];
const sessionsData = [8, 12, 10, 14, 13, 18];

const toPoints = (data: number[], maxVal: number, w: number, h: number) =>
  data.map((v, i) => `${(i / (data.length - 1)) * w},${h - (v / maxVal) * h}`).join(' ');

const DashboardSlide: React.FC = () => {
  const { t } = useTranslation();
  const m = t('demoTour.mockups.dashboard', { returnObjects: true }) as any;
  const W = 320, H = 70;

  return (
    <div className="dt-dash-layout">
      <div className="dt-dash-main">
        <div className="dt-dash-greeting">{m.greeting}</div>
        <div className="dt-dash-greeting-sub">{m.greetingSub}</div>

        <div className="dt-quicklinks">
          {m.quicklinks.map((q: string, i: number) => (
            <span key={q} className={`dt-quicklink ${i === 4 ? 'dt-quicklink--active' : ''}`}>{q}</span>
          ))}
        </div>

        <div className="dt-kpi-grid-4">
          {m.kpis.map((kpi: any) => (
            <div key={kpi.label} className="dt-kpi-card">
              <div className="dt-kpi-value" style={{ color: kpi.color }}>{kpi.value}</div>
              <div className="dt-kpi-label">{kpi.label}</div>
            </div>
          ))}
        </div>

        <div className="dt-chart-line">
          <div className="dt-chart-line-header">
            <span className="dt-chart-title">{m.chartTitle}</span>
            <span className="dt-chart-toggle">6M</span>
          </div>
          <svg viewBox={`0 0 ${W} ${H}`} className="dt-chart-svg" preserveAspectRatio="none">
            <polyline points={toPoints(revenueData, 2600, W, H)} fill="none" stroke="#2563eb" strokeWidth="2.5" strokeLinejoin="round" strokeLinecap="round" />
            <polyline points={toPoints(sessionsData, 20, W, H)} fill="none" stroke="#7dd3fc" strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" strokeDasharray="4 3" />
          </svg>
          <div className="dt-chart-months">
            {m.months.map((mo: string) => <span key={mo} className="dt-chart-label">{mo}</span>)}
          </div>
          <div className="dt-chart-legend">
            <span><span className="dt-legend-dot" style={{ background: '#2563eb' }} /> {m.legendRevenue}</span>
            <span><span className="dt-legend-dot" style={{ background: '#7dd3fc' }} /> {m.legendSessions}</span>
          </div>
        </div>

        <div className="dt-sessions">
          <div className="dt-sessions-title">{m.sessionsTitle}</div>
          {m.sessions.map((s: any) => (
            <div key={s.name} className="dt-sessions-row">
              <span className="dt-sessions-date">{s.date}</span>
              <span className="dt-sessions-name">{s.name}</span>
              <span className="dt-sessions-type">{s.type}</span>
              <span className="dt-sessions-time">{s.time}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="dt-sidebar">
        <div className="dt-sidebar-block">
          <div className="dt-sidebar-heading">
            {m.tasksTitle} <span className="dt-sidebar-badge">3</span>
          </div>
          {m.tasks.map((task: string) => (
            <div key={task} className="dt-sidebar-item">{task}</div>
          ))}
        </div>
        <div className="dt-sidebar-block">
          <div className="dt-sidebar-heading">{m.quickAccessTitle}</div>
          <div className="dt-sidebar-grid">
            {m.quickAccess.map((link: string) => (
              <span key={link} className="dt-sidebar-link">{link}</span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardSlide;
